import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const useHerobanner = (data, rotationInterval = 5000) => { // default 5 seconds
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef(null);
  const searchSectionRef = useRef(null);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [query, setQuery] = useState("");
  const [currentSet, setCurrentSet] = useState(null);
  const [setIndex, setSetIndex] = useState(0);

  /* ------------------ HERO SET CACHE ------------------ */
  useEffect(() => {
    if (!data?.hero_banners) return;

    const sets = Object.values(data.hero_banners).filter(
      (set) =>
        Array.isArray(set) &&
        [1, 2, 3, 4].every((seq) =>
          set.some((img) => img.sequence === seq)
        )
    );

    if (sets.length) {
      localStorage.setItem("hero_all_sets", JSON.stringify(sets));
    }
  }, [data]);

  /* ------------------ ROTATE HERO SETS ------------------ */
  useEffect(() => {
    const cached = localStorage.getItem("hero_all_sets");
    if (!cached) return;

    const sets = JSON.parse(cached);
    if (!sets.length) return;

    // Initialize with first set
    setCurrentSet(sets[0]);
    setSetIndex(0);

    // Rotate every rotationInterval
    const interval = setInterval(() => {
      setSetIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % sets.length;
        setCurrentSet(sets[nextIndex]);
        return nextIndex;
      });
    }, rotationInterval);

    return () => clearInterval(interval);
  }, [location.key, rotationInterval]);

  return {
    currentSet,
    setIndex,
    isSearchActive,
    setIsSearchActive,
    query,
    setQuery,
    inputRef,
    searchSectionRef,
    navigate,
  };
};

export default useHerobanner;
